import Notice from "./Notice";
import AttentionNotice from "./AttentionNotice";
import NegativeNotice from "./NegativeNotice";
import PositiveNotice from "./PositiveNotice";
export default Notice;
export { Notice, AttentionNotice, NegativeNotice, PositiveNotice };